import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=29ac3173&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=js&"
export * from "./Switcher.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Switcher.vue?vue&type=style&index=0&id=29ac3173&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "29ac3173",
  null
  ,true
)

export default component.exports